console.log('%cWebsite Made by %cOneDoBit%c https://nedobitkov.com', 
  'color: #FFF; background-color: #111; font-size: 16px;', // Style for "Made by"
  'color: #fb9389; background-color: #111; font-size: 16px; font-weight: bold;', // Style for "OneDoBit"
  'color: red; font-size: 16px; background-color: #111;' // Style for the URL
);
setTimeout(() => {
  console.log('%cWebsite Made by %cOneDoBit%c https://nedobitkov.com', 
    'color: #FFF; background-color: #111; font-size: 16px;', // Style for "Made by"
    'color: #fb9389; background-color: #111; font-size: 16px; font-weight: bold;', // Style for "OneDoBit"
    'color: red; font-size: 16px; background-color: #111;' // Style for the URL
  );
}, 10000)

let sizeButton = document.querySelector('.sizeGuide')

if (sizeButton) {
  let sizeButtonText = sizeButton.querySelector('.size')
  let sizeModalWrapper = document.querySelector('.size-modal-wrapper')
  let sizeModal = document.querySelector('.size-modal')
  if(sizeButtonText) {
    sizeButtonText.addEventListener('click', function() {
      if(sizeModalWrapper.classList.contains('closed'))
      {
        sizeModalWrapper.classList.remove('closed')
        sizeModalWrapper.style.height = sizeModal.getBoundingClientRect().height + 'px'
        setTimeout(() => {
          sizeModalWrapper.style.opacity = 1
        }, 200)
        window.scrollTo({
          top: sizeModal.getBoundingClientRect().top + window.scrollY - (window.innerHeight / 2),
          behavior: 'smooth'
        })
      } else {
        sizeModalWrapper.classList.add('closed')
        sizeModalWrapper.style.opacity = 0
        setTimeout(() => {
          sizeModalWrapper.style.height = 0
        }, 200)
      }
    })
  }
}